import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
// Styles
import {
   Form,
   FormItem,
   StyledInput,
   StyledLabel,
   StyledTextArea,
   Title,
   Wrapper,
} from "./AccountAddress.styles"

const AccountAddress = ({ role, address, setAddress, setUpdate }) => {
   const { t } = useTranslation()

   const handleChange = (e) => {
      setAddress((prev) => {
         return { ...prev, [e.target.name]: e.target.value }
      })
      setUpdate((prev) => {
         return { ...prev, [role + " / " + e.target.name]: e.target.value }
      })
   }

   return (
      <Wrapper>
         <Title>
            {role === "delivery"
               ? t("accountAddress.title.t1")
               : t("accountAddress.title.t2")}
         </Title>
         <Form>
            <FormItem>
               <StyledLabel>{t("accountAddress.label.l1")}</StyledLabel>
               <StyledInput
                  type="text"
                  name="name"
                  defaultValue={address?.name}
                  onChange={handleChange}
               />
            </FormItem>
            <FormItem>
               <StyledLabel>{t("accountAddress.label.l2")}</StyledLabel>
               <StyledInput
                  type="text"
                  name="street"
                  defaultValue={address?.street}
                  onChange={handleChange}
               />
            </FormItem>
            <FormItem>
               <StyledLabel>{t("accountAddress.label.l3")}</StyledLabel>
               <StyledInput
                  type="text"
                  name="zipCode"
                  defaultValue={address?.zipCode}
                  onChange={handleChange}
               />
            </FormItem>
            <FormItem>
               <StyledLabel>{t("accountAddress.label.l4")}</StyledLabel>
               <StyledInput
                  type="text"
                  name="city"
                  defaultValue={address?.city}
                  onChange={handleChange}
               />
            </FormItem>
            <FormItem>
               <StyledLabel>{t("accountAddress.label.l5")}</StyledLabel>
               <StyledInput
                  type="text"
                  name="region"
                  defaultValue={address?.region}
                  onChange={handleChange}
               />
            </FormItem>
            <FormItem>
               <StyledLabel>{t("accountAddress.label.l6")}</StyledLabel>
               <StyledInput
                  type="text"
                  name="country"
                  defaultValue={address?.country}
                  onChange={handleChange}
               />
            </FormItem>
            <FormItem>
               <StyledLabel>{t("accountAddress.label.l7")}</StyledLabel>
               <StyledTextArea
                  name="info"
                  defaultValue={address?.info}
                  onChange={handleChange}
               />
            </FormItem>
         </Form>
      </Wrapper>
   )
}

AccountAddress.propTypes = {
   role: PropTypes.string,
   address: PropTypes.object,
   setAddress: PropTypes.func,
}

export default AccountAddress
